// components/AWSRegisterTextField.tsx
import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'

// Styled version with shared Input styling
const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    height: '38px',
    padding: '10px 0px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '6px',
    backgroundColor: '#fff',
    '& fieldset': {
      borderColor: '#E4E4E7',
    },
    '&:hover fieldset': {
      borderColor: '#E4E4E7',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#E4E4E7',
    },
  },
})

// Wrapper for reuse
const AWSRegisterTextField = (props: TextFieldProps) => (
  <StyledTextField fullWidth variant="outlined" {...props} />
)

export default AWSRegisterTextField
